import { render, staticRenderFns } from "./exExpertScoringComIndex.vue?vue&type=template&id=768fcbc6"
import script from "./exExpertScoringComIndex.vue?vue&type=script&lang=js"
export * from "./exExpertScoringComIndex.vue?vue&type=script&lang=js"
import style0 from "./exExpertScoringComIndex.vue?vue&type=style&index=0&id=768fcbc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports